/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 * Extracted ability-template data (was part of Abilities.ts). Pure data; consumed by Abilities.
*/

export const bonus_actions: Ability[] = [
		{
			name: "A Call to Arms",
			desc: "Once per encounter, as a bonus action, the [MON] can sound the alarm calling an additional 1d4 ??? to his side in 1d3 rounds.",
			group: "Bonus Actions"
		},
		{
			name: "Aggressive",
			desc: "As a bonus action, the [MON] can move up to its speed toward a hostile creature that it can see.",
			group: "Bonus Actions"
		},
		{
			name: "Butt Strike",
			desc: "When the [MON] takes the attack action with its polearm, it may make a melee attack with the butt of its polearm as a bonus action. *Melee Attack*: [STR ATK] to hit, reach same as polearm, one target. *Hit:* [STR 1D4] bludgeoning damage.",
			group: "Bonus Actions"
		},
		{
			name: "Cunning Action",
			desc: "On each of its turns, the [MON] can use a bonus action to take the Dash, Disengage, or Hide action.",
			group: "Bonus Actions"
		},
		{
			name: "Divine Eminence",
			desc: "As a bonus action, the [MON] can expend a spell slot to cause its melee weapon attacks to magically deal an extra [???d???] radiant damage to a target on a hit. This benefit lasts until the end of the turn. If the [MON] expends a spell slot of 2nd level or higher, the extra damage increases by 1d6 for each level above 1st.",
			group: "Bonus Actions"
		},
		{
			name: "Ethereal Jaunt",
			desc: "As a bonus action, the [MON] can magically shift from the Material Plane to the Ethereal Plane, or vice versa.",
			group: "Bonus Actions"
		},
		{
			name: "Misty Step",
			desc: "The [MON] teleports to an unoccupied space they can see within 30 feet.",
			group: "Bonus Actions"
		},
		{
			name: "Nimble Escape",
			desc: "The [MON] can take the Disengage or Hide action as a bonus action on each of its turns.",
			group: "Bonus Actions"
		},
		{
			name: "Rampage",
			desc: "When the [MON] reduces a creature to 0 hit points with a melee attack on its turn, the [MON] can take a bonus action to move up to half its speed and make a ??? attack.",
			group: "Bonus Actions"
		},
		{
			name: "Shadow Stealth",
			desc: "While in dim light or darkness, the [MON] can take the Hide action as a bonus action.",
			group: "Bonus Actions"
		},
		{
			name: "Shield Bash",
			desc: "*Melee Weapon Attack:* [STR ATK] to hit, reach 5 ft., one creature. *Hit:* [STR 1d4] bludgeoning damage. If the target is a Medium or smaller creature, it must succeed on a DC [STR SAVE] Strength saving throw or be knocked prone.",
			group: "Bonus Actions"
		},
	];
